import api from '../../api'
import {normalize} from 'normalizr';

export const PERIODS_RECEIVED = 'PERIODS_RECEIVED';
export const PERIODS_GRID_FILTER_CHANGED = 'PERIODS_GRID_FILTER_CHANGED';
export const PERIODS_GRID_SORT_CHANGED = 'PERIODS_GRID_SORT_CHANGED';
export const PERIODS_GRID_PAGINATION_CHANGED = 'PERIODS_GRID_PAGINATION_CHANGED';

export const fetchPeriods = (facilityId) => async (dispatch, getState, {schema}) => {
  await api(dispatch).get(facilityId ? `periods?facilityId=${facilityId}` : 'periods', data => ({
    type: PERIODS_RECEIVED,
    payload: normalize(data, [schema.reviewPeriod])
  }));
};

export const gridFilterChanged = (gridFilterModel) => ({
  type: PERIODS_GRID_FILTER_CHANGED,
  payload: gridFilterModel.map(x => ({ ...x }))
});

export const gridSortChanged = (gridSortModel) => ({
  type: PERIODS_GRID_SORT_CHANGED,
  payload: gridSortModel.map(x => ({ ...x }))
});

export const gridPaginationChanged = (currentPage) => ({
  type: PERIODS_GRID_PAGINATION_CHANGED,
  payload: {
    currentPage: currentPage
  }
});



// WEBPACK FOOTER //
// ./src/modules/periods/period.actions.js